import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";
import { useListEvents } from "../hooks/useListEvents";
import type { Event } from "../types/event";
import EventItem from "./EventItem";
import { SeeMoreLink } from "./common/SeeMoreLink";
import SkeletonLoader from "./common/SkeletonLoader";

const EventsWrapper = () => {
  const { isLoading, data } = useListEvents();

  const events = (data?.records || []).slice(0, 2) as Event[];

  return (
    <div className="mt-2">
      <div className="my-3">
        <Typography.BodySm weight="medium" color="text-tertiary">
          {t("support_widget_v2.explore_page.events")}
        </Typography.BodySm>
      </div>
      <div className="mb-4">
        {isLoading ? (
          <SkeletonLoader rows={2} height="80px" wrapperClassName="px-2" />
        ) : (
          events.map((event: Event) => (
            <EventItem key={event.id} event={event} />
          ))
        )}
      </div>
      <div>
        <SeeMoreLink onClick={() => {}} />
      </div>
    </div>
  );
};

export default EventsWrapper;
